import { create } from 'zustand';
const useDataStore = create()((set) => ({
    groups: [],
    apptypes: [],
    resources: [],
    products: [],
    categories: [],
    times: [],
    dates: [],
    setGroups: (groups) => set(() => ({ groups })),
    setApptypes: (apptypes) => set(() => ({ apptypes })),
    setResources: (resources) => set(() => ({ resources })),
    setProducts: (products) => set(() => ({ products })),
    setCategories: (categories) => set(() => ({ categories })),
    setTimes: (times) => set(() => ({ times })),
    setDates: (dates) => set(() => ({ dates })),
    getProduct: (productId) => {
        let dataState = useDataStore.getState();
        let product = dataState.products.find((product) => product.id === productId);
        if (!product) {
            dataState.products.map((_product) => {
                if (_product.variances && _product.variances.length > 0) {
                    let _variationProduct = _product.variances[0].variations.find((variationProduct) => variationProduct.id === productId);
                    if (_variationProduct) {
                        product = _product;
                        product.isVariation = true;
                        product.variation = _variationProduct;
                    }
                }
            });
        }
        else {
            if (product.variances && product.variances.length > 0) {
                let _variationProduct = product.variances[0].variations.find((variationProduct) => variationProduct.id === productId);
                if (_variationProduct) {
                    product.isVariation = true;
                    product.variation = _variationProduct;
                }
            }
        }
        return product;
    }
}));
export default useDataStore;
